import {
  GET_FEATURES_FLAGS,
  GET_FEATURES_FLAGS_SUCCESS,
  GET_FEATURES_FLAGS_ERROR,
  CREATE_FEATURES_FLAG,
  CREATE_FEATURES_FLAG_SUCCESS,
  CREATE_FEATURES_FLAG_ERROR,
  ENABLE_FEATURES_FLAG,
  ENABLE_FEATURES_FLAG_SUCCESS,
  ENABLE_FEATURES_FLAG_ERROR,
  DISABLE_FEATURES_FLAG,
  DISABLE_FEATURES_FLAG_SUCCESS,
  DISABLE_FEATURES_FLAG_ERROR,
  TOGGLE_FEATURES_FLAGS_ACCOUNTS,
  TOGGLE_FEATURES_FLAGS_ACCOUNTS_SUCCESS,
  TOGGLE_FEATURES_FLAGS_ACCOUNTS_ERROR,
  TOGGLE_FEATURES_FLAGS_ADMIN_USERS,
  TOGGLE_FEATURES_FLAGS_ADMIN_USERS_ERROR,
  TOGGLE_FEATURES_FLAGS_ADMIN_USERS_SUCCESS,
  GET_WHITELISTED_BRANDS_FEATURE_FLAGS,
  GET_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
  GET_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR,
  CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS,
  CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
  CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR,
  DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS,
  DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
  DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  features_flags: [],
  loading: false,
  whitelisted_brand_feature_flags: [],
  whitelisted_brand_feature_flags_loading: false,
  whitelisted_brand_feature_flags_error: null,
  features_flags_loaded: false
}

const featuresFlags = (state = initialState, action) => {
  switch (action.type) {

    case GET_FEATURES_FLAGS:
      return {
        ...state,
        loading: true
      }

    case GET_FEATURES_FLAGS_SUCCESS:
      return {
        ...state,
        features_flags: action.payload,
        loading: false,
        features_flags_loaded: true
      }

    case GET_FEATURES_FLAGS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        features_flags_loaded: true
      }

    case CREATE_FEATURES_FLAG:
      return {
        ...state,
        loading: true
      }

    case CREATE_FEATURES_FLAG_SUCCESS:
      return {
        ...state,
        features_flags: [...state.features_flags, { ...action.payload }],
        loading: false
      }

    case CREATE_FEATURES_FLAG_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case ENABLE_FEATURES_FLAG:
      return {
        ...state,
        loading: true
      }

    case ENABLE_FEATURES_FLAG_SUCCESS:
      return {
        ...state,
        features_flags: state.features_flags.map((features_flag) => (features_flag.key == action.payload.key ? { features_flag, ...action.payload } : features_flag)),
        loading: false
      }

    case ENABLE_FEATURES_FLAG_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DISABLE_FEATURES_FLAG:
      return {
        ...state,
        loading: true
      }

    case DISABLE_FEATURES_FLAG_SUCCESS:
      return {
        ...state,
        features_flags: state.features_flags.map((features_flag) => (features_flag.key == action.payload.key ? { features_flag, ...action.payload } : features_flag)),
        loading: false
      }

    case DISABLE_FEATURES_FLAG_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case TOGGLE_FEATURES_FLAGS_ACCOUNTS_SUCCESS:
      return {
        ...state,
        //TODO: fix this based on server response
        //features_flags: state.features_flags.map((features_flag) => (features_flag.key == action.payload.key ? { features_flag, ...action.payload } : features_flag)),
        loading: false
      }

    case TOGGLE_FEATURES_FLAGS_ACCOUNTS:
      return {
        ...state,
        loading: true
      }

    case TOGGLE_FEATURES_FLAGS_ACCOUNTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case TOGGLE_FEATURES_FLAGS_ADMIN_USERS_SUCCESS:
      return {
        ...state,
        //TODO: fix this based on server response
        //features_flags: state.features_flags.map((features_flag) => (features_flag.key == action.payload.key ? { features_flag, ...action.payload } : features_flag)),
        loading: false
      }

    case TOGGLE_FEATURES_FLAGS_ADMIN_USERS:
      return {
        ...state,
        loading: true
      }

    case TOGGLE_FEATURES_FLAGS_ADMIN_USERS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_WHITELISTED_BRANDS_FEATURE_FLAGS:
      return {
        ...state,
        whitelisted_brand_feature_flags_loading: true
      }

    case GET_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        whitelisted_brand_feature_flags: action.payload,
        whitelisted_brand_feature_flags_loading: false
      }

    case GET_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        whitelisted_brand_feature_flags_error: action.payload,
        whitelisted_brand_feature_flags_loading: false
      }

    case CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS:
      return {
        ...state,
        whitelisted_brand_feature_flags_loading: true
      }

    case CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        whitelisted_brand_feature_flags: state.whitelisted_brand_feature_flags.map((brand_feature_flag) => (brand_feature_flag.id == action.payload.id ? { brand_feature_flag, ...action.payload } : brand_feature_flag)),
        whitelisted_brand_feature_flags_loading: false
      }

    case CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        whitelisted_brand_feature_flags_error: action.payload,
        whitelisted_brand_feature_flags_loading: false
      }

    case DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS:
      return {
        ...state,
        whitelisted_brand_feature_flags_loading: true
      }

    case DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        whitelisted_brand_feature_flags: state.whitelisted_brand_feature_flags.map((brand_feature_flag) => (brand_feature_flag.id == action.payload.id ? { brand_feature_flag, ...action.payload } : brand_feature_flag)),
        whitelisted_brand_feature_flags_loading: false
      }

    case DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        whitelisted_brand_feature_flags_error: action.payload,
        whitelisted_brand_feature_flags_loading: false
      }

    default:
      return state
  }
}

export default featuresFlags;
